/**
 * This file handles triggering metrics beacons.
	- it must have the standard Adobe Beacon loaded on the page:
		/JScript/metrics/adobe/analytics_cdcgov.js
	- it only runs in the browser
 */

const $ = window.jQuery || window.$;

/**
 *	Base settings
 *		prop3   document.title;
 *		prop48  document.referrer.split('?')[0];
 *		eVar5   '+1' (incrementing)
 *
 *	Page view
 *		prop28  siteLimit
 *		eVar76  newTerms (history of searched terms)
 *
 *	AB Testing for faceted search
 *		prop64  AB Test Name
 *		eVar63  AB Test value
 *
 *	Click event
 *		prop40  'ci-' + label + ': ' + interaction;
 *
 *	Click AB Test
 *		evar18 AB Test value
 */
const metrics = {
	/**
	 * Click tracking
	 * @param string area
	 * @param string action
	 */
	clickTrack(event, area, action) {
		if (!$) {
			return;
		}
		let $el = (event && event.currentTarget) ? $(event.currentTarget) : $('content-collection:first');

		let options = [area];
		if (action) {
			options.push(action);
		}
		$el.trigger('metrics-capture', options);
	}
};

export default metrics;
